export * from "modules/AppointmentDetails/components/Interventions/components/Replacements/components/ReplacementsTable";
